import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import URL from "../../../constants/url";

import style from './AllowAccess.module.css';



const AllowAccess = () => {

    const navigate = useNavigate();

    return (
        <>
            <div className='container' data-padding='none' data-bg-color="white">
                <div className='inner-wrap' data-pad="normal">

                    <div className={style['top-box']}>
                        <strong>
                            앱 사용을 위해 <br />
                            접근 권한을 허용해 주세요
                        </strong>
                        <div className={style['li-box']}>
                            <ul>
                                <li data-list="1">
                                    <div>
                                        <p>푸시 알림 동의</p>
                                        <span>진료 예약, 공지 등 알림 메시지 전송</span>
                                    </div>
                                </li>
                                <li data-list="2">
                                    <div>
                                        <p>마이크</p>
                                        <span>비대면 진료(영상/음성 통화) 이용</span>
                                    </div>
                                </li>
                                <li data-list="3">
                                    <div>
                                        <p>카메라</p>
                                        <span>비대면 진료(영상 통화) 이용</span>
                                    </div>
                                </li>
                                <li data-list="4">
                                    <div>
                                        <p>위치서비스</p>
                                        <span>가까운 약국 검색</span>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div className={style['bottom-box']}>
                        <p>
                        접근 권한에 동의하지 않아도 <br />
                        서비스를 이용할 수 있으나 일부 기능 사용에 <br />
                        제한이 있을 수 있습니다.
                        </p>
                        <button className='btn'data-btn-type="fill-main" data-btn-size='lg' onClick={() => navigate(URL.LANDING)}>
                            <span>확인</span>
                        </button>
                    </div>

                </div>
            </div>
        </>
    )
}

export default AllowAccess